import { render, staticRenderFns } from "./releaf-factory-summary.vue?vue&type=template&id=6a6766bc&scoped=true&"
import script from "./releaf-factory-summary.vue?vue&type=script&lang=js&"
export * from "./releaf-factory-summary.vue?vue&type=script&lang=js&"
import style0 from "./releaf-factory-summary.vue?vue&type=style&index=0&id=6a6766bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6766bc",
  null
  
)

export default component.exports